export default "__VITE_ASSET__DjkBSovR__"